// extracted by mini-css-extract-plugin
export default {"lable":"i2_lable__tbttn","duo":"i2_duo__04xvm","cover":"i2_cover__3Z5A1","duo2":"i2_duo2__+LXhg","cover2":"i2_cover2__mXsg1"};